import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { MissionStaffStatusEnum } from '../../lib/types/enums/mission/mission-staff-status.enum'
import { MissionToStaffMission } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type StaffMissionFilters = {
  statuses?: MissionStaffStatusEnum[]
}

export const getStaffMissions = async (
  id: number,
  input?: PaginationRequest<StaffMissionFilters>
) => {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.staffs.getStaffMissions.url, { id }),
        input
      )
    )
    .get<PaginationResponse<MissionToStaffMission>>()
}
